/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md:
   this file exports a function, not a React component. */
// Own-property read: a getRowId returning 'toString' would otherwise resolve to the inherited
// method, whose .length of 0 reads as "fetched and empty" and suppresses the row's toggle.
export function readCachedChildren<TChild>(
  childRowsByParentId: Readonly<Record<string, TChild[] | undefined>>,
  parentId: string,
): TChild[] | undefined {
  return Object.hasOwn(childRowsByParentId, parentId) ? childRowsByParentId[parentId] : undefined;
}
